import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import {
  NgbCollapseModule,
  NgbDatepickerModule,
  NgbDropdownModule,
} from '@ng-bootstrap/ng-bootstrap';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { PageModule } from '@abp/ng.components/page';
import { EventTicketComponent } from './event-ticket.component';
import { EventTicketRoutingModule } from './event-ticket-routing.module';
import { QRCodeModule } from 'angularx-qrcode';

@NgModule({
  declarations: [EventTicketComponent],
  imports: [
    EventTicketRoutingModule,
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgxValidateCoreModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    PageModule,
    QRCodeModule
  ],
})
export class EventTicketModule {}
